<template>
  <div class="animated fadeIn">
    <b-card no-body class="card-default mt-3 vh-85" v-if="recientesShow">
      <!--- #################### MODAL RECURSOS ############## -->
      <b-modal id="modalResource" :title="resourceView.file || ''" ref="modal-resource">
        <b-row>
          <b-col>
            <img
              v-if="resourceView.type == 'IMAGEN'"
              class="img-preview"
              :src="$root.setUrlFile(resourceView.file)"
            />
            <audio
              v-else-if="resourceView.type == 'AUDIO'"
              class="audio-preview"
              controls
              autobuffer
            >
              <source :src="$root.setUrlFile(resourceView.file)" />
            </audio>
            <video v-else class="video-preview" controls>
              <source :src="$root.setUrlFile(resourceView.file)" />
            </video>
            <p
              class="text-center mt-2"
              v-if="resourceView.fechaCreacion"
            >Fecha de Registro: {{ resourceView.fechaCreacion | moment("DD/MM/YYYY") }}</p>
            <p>Tags Registradas</p>
          </b-col>
        </b-row>
        <b-row class="justify-content-start">
          <b-col class="mb-2" v-for="(tag, index) in resourceView.tags" :key="index">
            <b-col class="tag-recurso">
              <p>{{ tag }}</p>
            </b-col>
          </b-col>
        </b-row>
      </b-modal>
      <!-- ######################################################### -->
      <div slot="header">
        <span>
          <strong>Elementos Recientes</strong>
        </span>
      </div>
      <b-card-body>
        <b-row>
          <b-col lg="12">
            <p>
              Elementos agregados los últimos
              <strong>30 días</strong>
            </p>
          </b-col>
        </b-row>
        <b-row class="text-center">
          <template v-if="finalData.length > 0">
            <template v-for="(elm, i) in finalData">
              <b-col
                :key="i"
                lg="2"
                md="3"
                sm="6"
                class="box-element item-list-view animated fadeIn"
                v-if="elm.type == 'material'"
                @dblclick="openMaterial(elm.data)"
              >
                <b-dropdown
                  size="sm"
                  dropleft
                  variant="light"
                  class="m-0 icon-options-item"
                  no-caret
                  v-if="showButtons"
                >
                  <template slot="button-content">
                    <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                  </template>
                  <b-dropdown-item @click="changeNameMat(elm.data)">Cambiar Nombre</b-dropdown-item>
                  <b-dropdown-item
                    v-if="elm.data.estatus == 'ACTIVO'"
                    @click="removeMat(elm.data)"
                  >Eliminar</b-dropdown-item>
                  <b-dropdown-item
                    v-if="elm.data.estatus == 'ACTIVO'"
                    @click="editarMat(elm.data)"
                  >Editar</b-dropdown-item>
                </b-dropdown>

                <!--<font-awesome-icon v-if="elm.type == 'dir'" icon="folder" class="icon-dir"></font-awesome-icon>-->
                <font-awesome-icon
                  v-b-popover.hover.bottom="elm.data.name"
                  icon="file-invoice"
                  class="icon-mat"
                ></font-awesome-icon>
                <!--<font-awesome-icon v-else icon="paperclip" class="icon-dir"></font-awesome-icon>-->

                <span
                  class="d-block text-center"
                  style="margin-right: 20px;"
                  variant="primary"
                >{{ elm.data.name }}</span>

                <!--Muestra en un popover el nombre de archivo-->
                <!--<span v-if="elm.type == 'dir' || elm.type == 'material'" 
                class="d-block"
                v-b-popover.hover.bottom="elm.data.name"
                variant="primary"
              >
                <span v-if="elm.type == 'dir'" class="d-block"><strong>{{ elm.data.name }}</strong></span>
                <span v-else class="d-block"><strong>{{ elm.data.name }}</strong></span>
                </span>-->
                <!--<span v-if="elm.type == 'resource'" 
                class="d-block"
                v-b-popover.hover.bottom="elm.data.file"
                variant="primary"
                >Recurso<br><strong>{{ elm.data.file }}</strong></span>-->
              </b-col>
              <b-col
                :key="i"
                lg="2"
                md="3"
                sm="6"
                class="box-element item-list-view animated fadeIn"
                v-if="elm.type == 'dir'"
                @dblclick="openDir(elm.data)"
              >
              <b-dropdown
                  size="sm"
                  dropleft
                  variant="light"
                  class="m-0 icon-options-item"
                  no-caret
                  v-if="showButtons"
                >
                  <template slot="button-content">
                    <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                  </template>
                  <b-dropdown-item @click="changeName(elm.data)">Cambiar Nombre</b-dropdown-item>
                  <b-dropdown-item
                    v-if="elm.data.estatus == 'ACTIVO'"
                    @click="removeDir(elm.data)"
                  >Eliminar</b-dropdown-item>
                </b-dropdown>
                <!--<font-awesome-icon v-if="elm.type == 'dir'" icon="folder" class="icon-dir"></font-awesome-icon>
              <font-awesome-icon
                v-else-if="elm.type == 'material'"
                icon="file-invoice"
                class="icon-dir"
              ></font-awesome-icon>
                <font-awesome-icon v-else icon="paperclip" class="icon-dir"></font-awesome-icon>-->
                <font-awesome-icon
                  v-b-popover.hover.bottom="elm.data.name"
                  icon="folder"
                  class="icon-dir"
                ></font-awesome-icon>
                <span class="d-block text-center" style="margin-right: 20px;" variant="primary">{{ elm.data.name }}</span>

                <!--Muestra en un popover el nombre de archivo-->
                <!--<span
                v-if="elm.type == 'dir' || elm.type == 'material'"
                class="d-block"
                v-b-popover.hover.bottom="'Nombre del archivo: ' +elm.data.name"
                variant="primary"
              >
                <span v-if="elm.type == 'dir'" class="d-block">
                  Carpeta
                  <br />
                  <strong>{{ elm.data.name }}</strong>
                </span>
                <span v-else class="d-block">
                  Material
                  <br />
                  <strong>{{ elm.data.name }}</strong>
                </span>
                </span>-->
                <!--<span
                v-if="elm.type == 'resource'"
                class="d-block"
                v-b-popover.hover.bottom="'Nombre del archivo: ' + elm.data.file"
                variant="primary"
              >
                Recurso
                <br />
                <strong>{{ elm.data.file }}</strong>
                </span>-->
              </b-col>
              <b-col
                :key="i"
                lg="2"
                md="3"
                sm="6"
                class="box-element item-list-view animated fadeIn"
                v-if="elm.type == 'resource'"
                @dblclick="openResource(elm.data)"
              >
                <!--<font-awesome-icon v-if="elm.type == 'dir'" icon="folder" class="icon-dir"></font-awesome-icon>
              <font-awesome-icon
                v-else-if="elm.type == 'material'"
                icon="file-invoice"
                class="icon-dir"
              ></font-awesome-icon>
                <font-awesome-icon v-else icon="paperclip" class="icon-dir"></font-awesome-icon>-->
                <font-awesome-icon icon="paperclip" class="icon-mat"></font-awesome-icon>

                <span
                  class="d-block text-center"
                  v-b-popover.hover.bottom="elm.data.file"
                  variant="primary"
                >{{ elm.data.file }}</span>

                <!--Muestra en un popover el nombre de archivo-->
                <!--<span
                v-if="elm.type == 'dir' || elm.type == 'material'"
                class="d-block"
                v-b-popover.hover.bottom="'Nombre del archivo: ' +elm.data.name"
                variant="primary"
              >
                <span v-if="elm.type == 'dir'" class="d-block">
                  Carpeta
                  <br />
                  <strong>{{ elm.data.name }}</strong>
                </span>
                <span v-else class="d-block">
                  Material
                  <br />
                  <strong>{{ elm.data.name }}</strong>
                </span>
                </span>-->
                <!--<span
                v-if="elm.type == 'resource'"
                class="d-block"
                v-b-popover.hover.bottom="'Nombre del archivo: ' + elm.data.file"
                variant="primary"
              >
                Recurso
                <br />
                <strong>{{ elm.data.file }}</strong>
                </span>-->
              </b-col>
            </template>
          </template>
          <template v-if="finalData.length == 0">
            <b-col lg="12" class="text-center">
              <h3
                style="padding-top: 200px; color: #bbb;"
              >No Existen Elementos Recientes para Mostrar</h3>
            </b-col>
          </template>
        </b-row>

        <!--
          <div role="tablist">
            <b-card no-body class="mb-1" v-for="(fd,i) in finalData">
              <b-card-header
                header-tag="header"
                v-b-toggle="'collapse'+i"
                class="p-2 title-header-collapse"
                role="tab">
                <span>{{fd.name}}</span>
              </b-card-header>
              <b-collapse :id="`collapse${i}`" visible role="tabpanel">
                <template v-if="fd.tree.length > 0">
                  <b-card-body>
                    <b-row class="text-center">
                      <template v-for="(dir,j) in fd.tree">
                        <b-col lg="2" md="3" sm="6" class="box-element item-list-view">
                          <b-dropdown
                            size="sm"
                            dropright
                            variant="light"
                            class="m-0 icon-options-item"
                            no-caret>
                            <template slot="button-content">
                              <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                            </template>
                            <b-dropdown-item>Eliminar</b-dropdown-item>
                            <b-dropdown-item @click="openDir(dir)">Abrir</b-dropdown-item>
                          </b-dropdown>
                          <i
                            :class="{'icon-folder-alt': dir.sub.length > 0, 'icon-folder': dir.sub.length == 0}"
                            class="icons font-5xl d-block"
                          ></i>
                          <span>{{dir.name}}</span>
                        </b-col>
                      </template>
                    </b-row>
                  </b-card-body>
                </template>
              </b-collapse>
            </b-card>
          </div> 
        -->
      </b-card-body>
    </b-card>
    <!--<DirectoriosContent
      v-if="!recientesShow"
      :dataDir="dataDirToSend"
      :dataMaterial="dataMaterialToSend"
      @returnAction="returnAction"
    ></DirectoriosContent>-->
  </div>
</template>
<script>
/*var author = {
  nombreUsuario: "Juan López",
  email: "juan@email.com"
};*/

import { Callout } from "@coreui/vue";
import DirectoriosContent from "@/components/DirectoriosContent";
import {
  sidebarCssClasses,
  asideMenuCssClasses,
  validBreakpoints,
  checkBreakpoint
} from "@coreui/vue/src/shared/classes";
import DirectorioService from "@/services/directorio.service";
import RecursoService from "@/services/recurso.service";
import MaterialService from "@/services/material.service";

export default {
  name: "dashboard",
  components: {
    Callout,
    DirectoriosContent
  },
  data() {
    return {
      dataDirectorios: [],
      dataResources: [],
      dataMaterial: [],
      finalData: [],
      resourceView: {},
      showView: false,
      recientesShow: true,
      dataDirToSend: {},
      dataMaterialToSend: [],
      showButtons: true
    };
  },
  created() {
    this.getDirectoryHistory(1);
    this.getResourcesHistory(1);
    this.getMaterialHistory(1);

    let body = document.getElementsByTagName("body");
    body[0].classList.add("sidebar-lg-show");
  },
  methods: {
    loadHistory(){
      this.getDirectoryHistory(1);
    this.getResourcesHistory(1);
    this.getMaterialHistory(1);
    },
    openClick(elm) {
      console.log(elm);
      if (elm.type == "dir")
        this.$router.push({ name: "Mis Cursos", params: { materia: dir._id } });
      else if (elm.type == "material")
        this.$router.push({ name: "Preview", params: { id: material._id } });
      else this.resourceView = resource;
      this.$refs["modal-resource"].show(); //sigue en prueba
    },
    processHistory() {
      var self = this;
      this.finalData = [];
      //console.log('data:::');
      //console.log(this.$moment().subtract(31, 'days').format());
      this.dataDirectorios.forEach(element => {
        self.finalData.push({ data: element, type: "dir" });
      });
      /* this.dataResources.forEach(element => {
        self.finalData.push({ 'data': element, 'type': 'resource' });
      }); */
      this.dataMaterial.forEach(element => {
        self.finalData.push({ data: element, type: "material" });
      });
      console.log("final data");
      console.log(this.finalData);
      return this.finalData;
    },
    getDirectoryHistory(pag) {
      var self = this;
      DirectorioService.list(pag, {
        filtro: {
          estatus: "ACTIVO",
          author: this.$store.getters["auth/infoUser"]._id,
          fechaCreacion: {
            $gte: this.$moment()
              .subtract(30, "days")
              .format()
          }
        }
      })
        .then(function(dir) {
          self.dataDirectorios = dir;
          self.processHistory();
        })
        .catch(err => {
          console.log("Err: ", err);
        });
    },
    getMaterialHistory(pag) {
      var self = this;
      MaterialService.list(pag, {
        filtro: {
          estatus: "ACTIVO",
          author: this.$store.getters["auth/infoUser"]._id,
          fechaCreacion: {
            $gte: this.$moment()
              .subtract(30, "days")
              .format()
          }
        }
      })
        .then(function(material) {
          self.dataMaterial = material;
          self.processHistory();
        })
        .catch(err => {
          console.log("Error: ", err);
        });
    },
    getResourcesHistory(pag) {
      var self = this;
      RecursoService.list(pag, {
        filtro: {
          $or: [
            { author: this.$store.getters["auth/infoUser"]._id },
            { compartido: { $in: [this.$store.getters["auth/infoUser"]._id] } }
          ],
          fechaCreacion: {
            $gte: this.$moment()
              .subtract(30, "days")
              .format()
          }
        }
      })
        .then(function(resources) {
          self.dataResources = resources;
          self.processHistory();
        })
        .catch(function(err) {
          console.log("Error: ", err);
        });
    },
    openResource(resource) {
      this.resourceView = resource;
      this.$refs["modal-resource"].show(); //sigue en prueba
      //this.$bvModal.show('modalResource');
    },
    openMaterial(material) {
      this.$router.push({ name: "Preview", params: { id: material._id } });
    },
    openDir(dir) {
      console.log("DirName: ", dir);
      this.$router.push({ name: "Mis Cursos", params: { materia: dir._id } });
      /*this.recientesShow = false;
      this.dataMaterialToSend = [];
      // buscar de todos los directorios el id correspondiente para obtener sus hijos correspondientes
      for (let i = 0; i < this.dataDirectorios.length; i++) {
        if (this.dataDirectorios[i].id == dir.id) {
          console.log(this.dataMaterial);
          // buscar material del directorio
          this.dataMaterial.forEach(material => {
            if(material.father.id == dir.id){
              this.dataMaterialToSend.push(material);
            }
          });
          this.dataDirToSend = dir;
        }
      }*/
    },
    returnAction(data) {
      this.recientesShow = data;
    },
    editarMat(material) {
      this.$router.push({
        name: "Editar Material",
        params: { id: material._id }
      });
    },
    changeNameMat(mtls) {
      this.$swal
        .fire({
          title: "Nuevo Nombre",
          input: "text",
          inputPlaceholder: mtls.name,
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Cambiar",
          cancelButtonText: "Cancelar"
        })
        .then(result => {
          if (result.value) {
            let data = {
              query: { _id: mtls._id },
              data: { name: result.value }
            };
            MaterialService.edit(data).then(response => {
              this.loadHistory();
            });
          }
        });
    },
    removeMat(mtls){
      this.$swal.fire({
        title: '¿Está Seguro?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar',
        cancelButtonText: 'No, Cancelar'
      }).then((result) => {
         if (result.value) {
          MaterialService.delete(mtls._id).then(response => {
            this.loadHistory();
          })
         }
      });
    },
    changeName(dir) {
       this.$swal.fire({
        title: 'Nuevo Nombre',
        input: 'text',
        inputPlaceholder:dir.name,
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Cambiar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if(result.value) {
          let data = {
            query: { "_id": dir._id },
            data: { name: result.value }
          };
          DirectorioService.edit(data).then(response => {
            this.loadHistory();
          });
        }
      })
    },
    removeDir(dir){
      this.$swal.fire({
          title: '¿Está seguro?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Eliminar',
          cancelButtonText: 'No, Cancelar'
      }).then((result) => {
          if (result.value) {
             DirectorioService.delete(dir._id).then(response => {
                console.log(response);
                this.loadHistory();
             });
          }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.title-header-collapse {
  cursor: pointer;
}
.item-list-view {
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
  cursor: pointer;
  &:hover {
    background-color: rgba(218, 235, 241, 0.5);

    .icon-options-item {
      visibility: initial;
    }
  }
  svg,
  span {
    text-align: center;
    //margin-right: 20px;
  }
}
.icon-options-item {
  visibility: hidden;
  float: right;
  margin-top: 10px;
}
.icon-dir {
  font-size: 4rem;
  color: #30a8d8;
  padding: 0.2rem;
}
.d-block {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>